<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Hearer  -->
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">Master Data</li>
                <li class="breadcrumb-item">User</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <!-- Card  -->
      <div class="card mt-5">
        <div class="card-header">
          <!-- Title -->
          <h4 class="card-header-title">User</h4>
          <!-- Button -->
          <!--
          <b-button v-if="isCreat" v-b-modal.modal-1 variant="primary" @click="addNew">
            <span class="fe fe-user-check mr-2"></span>
            Create User
          </b-button>
          -->
        </div>
        <div class="card-body">
          <div>
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label>Name</label>
                  <input name="name" type="text" class="form-control" v-model.trim="body.name" @input="handleNameInput"/>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>Email</label>
                  <input name="email" type="text" class="form-control" v-model.trim="body.email" @input="handleEmailInput" />
                </div>
              </div>
              <div class="col-lg-2">
                <label>Role</label>
                <v-select
                    :options="listRole"
                    v-model="body.role_id"
                    :reduce="(e) => e.value"
                    placeholder="Select/Type Here..."
                    class="w-md-auto"
                    @input="handleRoleChanges"
                />
              </div>
              <div class="col-lg-2">
                <b-button variant="primary" class="mt-4" @click="searchData">Filter</b-button>
                <b-button variant="primary" class="ml-1 mt-4" @click="resetFilterData">Reset Filter
                </b-button>
              </div>
            </div>
          </div>
        </div>
            <vue-good-table
            :line-numbers="true"
            :columns="columns"
            :rows="list.data"
            :sort-options="{
                        enabled: true,
                    }"
            :total-rows="list.totalItems"
            :pagination-options="{
                        enabled: true,
                        perPage: body.perPage,
                    }"
            style-class="vgt-table border-0 table"
            @on-page-change="onPageChange"
            @on-per-page-change="onPageChange"
            @on-sort-change="onSortChange">
          <!-- Loading -->
          <div slot="emptystate" class="text-center font-size-14">
            No data available
          </div>
          <!-- Custom Rows -->
          <template slot="table-row" slot-scope="props">
            <!-- Table Action -->
            <span v-if="props.column.field == 'departments'" class="flex-lg-wrap">
              {{departmentsOrganization(props.row?.departments)}}
            </span>
            <span v-else-if="props.column.field == 'action'">
              <b-button class="no-wrap btn-pill" variant="secondary" size="sm"
                        @click="detailData(props.row.id)">
                  <span class="fe fe-search"></span>
              </b-button>
              <b-button v-if="isUpdate" class="no-wrap btn-pill ml-2" variant="warning" size="sm" @click="editData(props.row.id)">
                  <span class="fe fe-edit"></span>
              </b-button>
              <b-button v-if="isDelete" class="no-wrap ml-2" variant="danger" style="margin-left: 5px" size="sm"
                        @click="deleteData(props.row.id)">
                  <span class="fe fe-trash-2"></span>
              </b-button>
          </span>
          </template>
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-end">
              <div>
                <b-pagination :value="1" :total-rows="list.totalItems" :per-page="body.pageSize"
                              first-number last-number align="right" prev-class="prev-item" next-class="next-item"
                              class="mr-3 mb-4 mt-0"
                              @input=" (value) => props.pageChanged({ currentPage: value })">
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

      </div>
    </div>
  </div>
</template>

<script>
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import index from "vuex";
import axiosIns from "@/api/axios";

export default {
  name: "ListUser",
  components: {ToggleSwitch},
  computed: {
    /*index() {
      return index
    },*/
    list() {
      return this.$store.getters["user/listData"];
    },
  },
  data() {
    return {
      body: {
        pageNumber: 1,
        pageSize: 10,
        search: "",
        field: "",
        order: "",
        name: "",
        email: "",
        role_id: ""
      },
      /*modalCreate: {
        department_code: "",
        department_name: "",
        fund_center: ""
      },
      modalUpdate: {
        department_code: "",
        department_name: "",
        fund_center: ""
      },*/
      modalDetail: {
        fullname: "",
        email: "",
        contact: "",
        role: "",
        divisi: "",
        department: "",
        subordinate_department: "",
        subordinate_member: "",
        budget_plan: "",
        created_at: "",
        created_by: "",
        updated_at: "",
        updated_by: ""
      },
      id: "",
      isAdd: true,
      isLoading: false,
      columns: [
        {
          label: "Full Name",
          field: "fullname",
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
          tdClass: "no-wrap color-secondary align-middle",
        },
          {
            label: "Email",
            field: "email",
            thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },
          {
            label: "Department",
            field: "departments",
            sortable: false,
            thClass: "table-header no-wrap w-40 text-muted font-weight-bold wrap-col",
            tdClass: "wrap-col wrap-col--desc color-secondary align-middle",
          },
          {
            label: "Role",
            field: "roles.role.roles_name",
            sortable: false,
            thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },

        /*
          {
            label: "Phone",
            field: "contact",
            thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },
          {
            label: "Role",
            field: "role_mapping.role.roles_name",
            sortable: false,
            thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },
        */
        {
          label: "Action",
          field: "action",
          sortable: false,
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold text-center",
          tdClass: "no-wrap color-secondary align-middle text-center",
        },
      ],
      listRole: [],
      selectedRole: null,
      paramName: null,
      paramEmail: null,
      paramRole: null,
      isRead: false,
      isCreat: false,
      isUpdate: false,
      isDelete: false
    };
  },

  mounted() {
    this.checkPermission();
    this.getList();
    this.getListRole();
    this.role_id = localStorage.getItem('roles')
  },
  methods: {
    departmentsOrganization(list) {
      let org = []
      list.forEach((value, index) => {
        if(value?.organization?.name){
          org.push(value?.organization?.name)
        }
      });
      let dt = org.slice(0, 2);
      let more = org.length > 2 ? ' ... ' : ''
      /*return org.toLocaleString().replaceAll(',', ', ')*/
      return dt.toLocaleString().replaceAll(',', ', ') + more
    },
    async checkPermission() {
      const roleName = localStorage.getItem("roles");
      const roleId = await axiosIns.get("/master-role/find-name?name=" + roleName);
      const menuId = await axiosIns.get("/master-menu/find-link?link=" + this.$route.path);
      const payloadPermission = {
        role_id: roleId.data.data[0]?.id || null,
        menu_id: menuId.data.data[0]?.id || null
      }
      const checkAuth = await axiosIns.post("/master-role/check-permission", payloadPermission);
      if(checkAuth.data.data?.authorization){
        this.isRead = checkAuth.data.data?.authorization.includes('read')
        this.isCreat = checkAuth.data.data?.authorization.includes('create')
        this.isUpdate = checkAuth.data.data?.authorization.includes('update')
        this.isDelete = checkAuth.data.data?.authorization.includes('delete')
      }
    },
    detailData(id) {

      this.$router.push(`/master-data/user/detail?id=${id}`)
    },
    editData(id) {

      this.$router.push(`/master-data/user/edit?id=${id}`)
    },
    addNew() {

      this.$router.push(`/master-data/user/add`)
    },

    getList() {
      this.$store.dispatch('user/GET_LIST_DATA', this.body)
    },
    async getListRole() {
      try {
        this.$store.dispatch('masterRole/GET_LIST_DATA', this.body)
        const response = await axiosIns.get("/master-role");
        this.listRole = response.data.data.data.map(items => ({
          label: items.roles_name,
          value: items.id
        }));
      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }

    },
    deleteData(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
              .dispatch("user/DELETE_DATA", id)
              .then((resp) => {
                this.getList();
                this.$swal("Deleted!", "User has been deleted", "success");
              })
              .catch((resp) => {
                this.$swal("Error", "Error while delete data", "error");
              });
        }
      });
    },

    // filter
    filterPage() {},

    sorting() {
      this.getList();
    },

    // Pagination
    onPageChange(payload) {
      this.body.limit = payload.currentPerPage;
      this.body.page = payload.currentPage;
      this.getList();
    },
    onSortChange(params) {
      let sort1 = params[0].field;
      let sort2 = params[0].type;
      this.body.field = sort1
      if (sort2 == 'none') {
        this.body.order = ''
      } else {
        this.body.order = sort2
      }
      this.getList();
    },
    searchData() {
      this.isLoading = true
      //let body = {}
      if (this.paramName !== null && this.paramName !== '') {
        this.body.name = this.paramName
      }
      if (this.paramEmail !== null && this.paramEmail !== '') {
        this.body.email = this.paramEmail
      }
      if (this.paramRole !== null && this.paramRole !== '') {
        this.body.role_id = this.paramRole
      }
      this.getList();
      /*this.$store.dispatch("budgetMonitor/GET_LIST_MONITOR", body).then((resp) => {
        this.isLoading = false
      })*/
    },
    resetFilterData() {
      this.isLoading = true
      this.body.name = null;
      this.body.email = null;
      this.body.role_id = null;
      this.getList();
    },
    handleNameInput() {
      if (this.body.name.length >= 3) {
        this.searchData()
      }else{
        this.getList();
      }
    },
    handleRoleChanges() {
      if (this.body.name.length >= 3) {
        this.searchData()
      }else{
        this.getList();
      }
    },
    handleEmailInput() {
      if (this.body.name.length >= 3) {
        this.searchData()
      }else{
        this.getList();
      }
    }
  },
};
</script>
